import React from 'react';
import {Select} from "antd";
import {typeReport} from "../common/typeReport";
import {useNavigate, useSearchParams} from "react-router-dom";
import {KeyFilter} from "../constant/keyFilter";
import {useDispatch, useSelector} from "react-redux";

const SelectTypeReport = props => {
    const [searchParams] = useSearchParams()
    let navigate = useNavigate()
    const dispatch = useDispatch()
    const {reloadData} = useSelector(state => state.layoutInteractionReducer)

    return (
            <Select
                defaultValue ={searchParams.get(KeyFilter.type_report) || typeReport[0]?.value}
                style={{width: "100%"}}
                // onChange={(value) => {
                //     searchParams.delete(KeyFilter.type_report)
                //     searchParams.append(KeyFilter.type_report, value)
                //     navigate(`?${searchParams.toString()}`)
                //     dispatch(onReloadData(!reloadData))
                // }}
                options={typeReport}
                dropdownStyle={{
                    padding: '12px',
                    minWidth: 180,
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap"
                }}
                {...props}
            />
    );
};


export default SelectTypeReport;
